
export class QuoteActionModel {
    accepted = 'ACCEPTED';
    cancel = 'CANCELLED';
    rejected = 'REJECTED';
    counterOffer = 'BID_PLACED';
}
